<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'input',
          label: 'CRMZ Business Id',
          key: 'crmzBusinessId',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'checkbox',
          label: 'Snapshot',
          key: 'snapshot',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Management',
          key: 'management',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Industries',
          key: 'industries',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Branches & Subsidiaries',
          key: 'branchesSubsidiaries',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'FRISK Score',
          key: 'friskScore',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Moodys Rating',
          key: 'moodysRating',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'S&P Rating',
          key: 'sPRating',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Z Score',
          key: 'zscore',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Standard Ratios',
          key: 'aSRatios',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Standard Balance Sheet',
          key: 'aSBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Standard Income Statement',
          key: 'aSIncomeStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Standard Cash Flow Statement',
          key: 'aSCashFlowStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Detail Balance Sheet',
          key: 'aDBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Detail Income Statement',
          key: 'aDIncomeStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Annual Detail Cash Flow Statement',
          key: 'aDCashFlowStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Ratios',
          key: 'yoySRatios',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Balance Sheet',
          key: 'yoySBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Income Statement (Quarterly)',
          key: 'yoySIncomeStatementQ',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Income Statement (Year To Date)',
          key: 'yoySIncomeStatementY',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Income Statement (Comparative)',
          key: 'yoySIncomeStatementC',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Standard Cash Flow Statement',
          key: 'yoySCashFlowStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Detail Balance Sheet',
          key: 'yoyDBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Detail Income Statement (Quarterly)',
          key: 'yoyDIncomeStatementQ',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Detail Income Statement (Year To Date)',
          key: 'yoyDIncomeStatementY',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'YOY Detail Cash Flow Statement',
          key: 'yoyDCashFlowStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Sequential Standard Ratios',
          key: 'sSRatios',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Sequential Standard Balance Sheet',
          key: 'sSBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Sequential Standard Income Statement',
          key: 'sSIncomeStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Sequential Detail Balance Sheet',
          key: 'sDBalanceSheet',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Sequential Detail Income Statement',
          key: 'sDIncomeStatement',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Management Discussion and Analysis',
          key: 'managementDiscussionAnalysis',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Peer Analysis Summary',
          key: 'peerAnalysisSummary',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Payment Summary By Month',
          key: 'paymentSummaryByMonth',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Payment Detail By Provider Account',
          key: 'paymentDetailByProviderAccount',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Suits and Judgments',
          key: 'suitsAndJudgments',
          defaultValue: false,
        },
        {
          type: 'checkbox',
          label: 'Tax Liens',
          key: 'taxLiens',
          defaultValue: false,
        },
      ],
    }
  },
  methods: {
    async validate() {
      const result = await this.$refs.form.validateForm()

      Object.keys(result).forEach(key => {
        const value = result[key]
        if (typeof value === 'boolean') {
          value ? (result[key] = 1) : (result[key] = 0)
        }
      })
      return result
    },
  },
  components: {
    MForm,
  },
}
</script>
